import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Sidebar from "../components/Sidebar";
import { calculatorGroups } from "../data/calculators";

function Calculators() {
  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">
            {/* <FaCalculator className="me-2" style={{ color: "var(--brand)" }} /> */}
            Calculators
          </h2>

          <article className="article mb-4">
            <div className="article-inner">
              <p className="mb-0 text-muted-2">
                Free online calculators to plan your money smartly. Pick a category
                below each one opens a set of related calculators with instant,
                accurate results. No signup required.
              </p>
            </div>
          </article>

          {/* Calculator group cards */}
          <Row className="g-4">
            {calculatorGroups.map((g) => (
              <Col sm={6} key={g.slug}>
                <Link to={`/calculators/${g.slug}`}>
                  <div className="calc-card" style={{ borderTopColor: g.color }}>
                    <div className="calc-card-img-wrap">
                      <img src={g.image} alt={g.name} className="calc-card-img" />
                    </div>
                    <div className="calc-card-body">
                      <h3 className="calc-card-title">{g.name}</h3>
                      <p className="text-muted-2 small flex-grow-1">{g.short}</p>
                      <div className="calc-card-tags mb-2">
                        {g.items.map((it) => (
                          <span className="calc-tag" key={it.key}>{it.title}</span>
                        ))}
                      </div>
                      <span className="calc-card-link" style={{ color: g.color }}>
                        Open <FaArrowRight size={12} />
                      </span>
                    </div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>

          {/* Info */}
          <article className="article mt-5">
            <div className="article-inner">
              <h2>Why Use Our Calculators?</h2>
              <p>
                Financial decisions are easier when you can see the numbers clearly.
                These calculators remove guesswork instantly know your loan EMI, SIP
                growth, FD maturity, taxes and more.
              </p>
              <div className="disclaimer-box">
                <strong>Disclaimer:</strong> These calculators provide estimates for
                informational purposes only. Actual values may vary based on bank
                policies, fees and exact calculation methods.
              </div>
            </div>
          </article>
        </Col>

        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default Calculators;
